import { Injectable } from '@angular/core';

import { filter } from 'rxjs';

import { Store } from '@ngrx/store';

import { setCompleteUIState } from '../../shared/store/ui.actions';
import { setCompleteUserState } from '../../user/store/user.actions';
import { getChannel, loadChannels, setChannelsFilter, setCompleteChatState } from '../store/chat.actions';
import { AppStateWithChat } from '../store/chat.reducer';

@Injectable({ providedIn: 'root' })
export class MessagingStateService {
  state: AppStateWithChat;
  savedState: Record<string, AppStateWithChat>;
  constructor(private store: Store<AppStateWithChat>) {
    this.getStateSubscriptions();
  }

  getStateSubscriptions() {
    this.store.pipe(filter((data) => data !== undefined)).subscribe((data) => {
      this.state = data;
    });
  }

  saveState(key: string): void {
    if (!this.savedState) {
      this.savedState = {};
    }
    this.savedState[key] = { ...this.state };
  }

  hasSavedState(key: string): boolean {
    if (!this.savedState || !key) {
      return false;
    }
    return this.savedState[key] ? true : false;
  }

  loadState(key: string): void {
    if (key && this.savedState && this.savedState[key]) {
      this.store.dispatch(setCompleteUserState({ savedState: this.savedState[key].user }));
      this.store.dispatch(setCompleteUIState({ savedState: this.savedState[key].ui }));
      this.store.dispatch(setCompleteChatState({ savedState: this.savedState[key].chat }));
      this.store.dispatch(setChannelsFilter({ filter: { ...this.savedState[key]?.chat.channelsFilter, page: 1 } }));
      this.store.dispatch(
        loadChannels({
          autoSelectChannel: false,
          setLoading: false,
          concat: false,
        })
      );
      if (this.savedState[key]?.chat?.selectedChannel) {
        this.store.dispatch(getChannel({ channelUID: this.savedState[key]?.chat?.selectedChannel.uid, autoSelect: true }));
      }
      delete this.savedState[key];
    }
  }
}
